import { getRuntimeEnv } from "./runtimeConfig";

const stripProtocolAndSlash = (value) =>
  String(value || "")
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/\/+$/, "");

const escapeForRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const resolveHttpsHost = () => {
  const ENV = getRuntimeEnv("REACT_APP_ENV") || "staging-api";
  const host = stripProtocolAndSlash(ENV);
  const hostFromEnv = !host
    ? "staging-api.credissuer.com"
    : host.includes(".")
      ? host
      : `${host}.credissuer.com`;
  return getRuntimeEnv("REACT_APP_HTTPS_HOST") || `https://${hostFromEnv}/`;
};

const AppConstants = {
  TENANT: { tenant: "Uganda" },
  ENTITY: { entity: "Exporter" },
  GOOGLE_CLIENT: { client_name: "google" },
  MICROSOFT_RESPONSE_TYPE: "code",
  MICROSOFT_RESPONSE_MODE: "query",
  MICROSOFT_SCOPE: "openid email profile offline_access User.Read",
  MICROSOFT_STATE: "12345",
  MICROSOFT_GRANT_TYPE: "authorization_code",
  MICROSOFT_CLIENT: "microsft",

  get CLIENT_ID() {
    return getRuntimeEnv("REACT_APP_GOOGLE_CLIENT_ID");
  },
  get MICROSOFT_CLIENT_ID() {
    return getRuntimeEnv("REACT_APP_MICROSOFT_CLIENT_ID");
  },
  get GOOGLE_CAPTCHA_SITE_KEY() {
    return getRuntimeEnv("REACT_APP_GOOGLE_CAPTCHA_SITE_KEY");
  },
  get HTTPS_HOST() {
    return resolveHttpsHost();
  },

  HOST: "localhost",
  get HOST_REGEX() {
    const HTTPS_HOST = resolveHttpsHost();
    return new RegExp(
      `^${escapeForRegExp(
        HTTPS_HOST.replace(/\/+$/, "").replace(/\/api$/, ""),
      )}/api`,
    );
  },
};
export default AppConstants;
